import { useMemo, useState } from "react";
import { Item } from "@/types/fse";

export const usePagination = (data: Item[]) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const itemsPerPage = 50;

  const { displayItems, totalPages } = useMemo(() => {
    const displayItems = data;
    const totalPages = Math.ceil(displayItems.length / itemsPerPage);

    return { displayItems, totalPages };
  }, [data, itemsPerPage]);

  return {
    displayItems,
    totalPages,
    setCurrentPage,
    itemsPerPage,
    currentPage,
  };
};
